export function init() {
    qAll('.modal').forEach(el => el.control = new Modal(el))

    app.modalGetAQuote = qOne('.modal.get-a-quote')
    app.modalCallMe    = qOne('.modal.call-me')
    app.modalMenu      = qOne('.modal.modal-menu')
    app.modalNewReview = qOne('.modal.modal-new-review')

    // app.modalNewReview?.control?.open();
    //test modals
    // app.modalMenu?.control?.open()

    document.addEventListener('click', e => {
        e.target.matches('[data-modal-quote]') && app.modalGetAQuote?.control?.open()
        e.target.matches('[data-modal-call-me]') && app.modalCallMe?.control?.open()
        e.target.matches('[data-modal-menu]') && app.modalMenu?.control?.open()
        e.target.matches('[data-modal-new-review]') && app.modalNewReview?.control?.open()

        if (e.target.hasAttribute('data-open-modal')) {
            document.getElementById(e.target.dataset.openModal)?.control?.open()

        }
    })
}

export class Modal {
    constructor(el) {
        this.$el = el

        this.$el.querySelectorAll('[data-close]').forEach(c => {
            c.addEventListener('click', () => this.close())
        })
    }

    open() {
        document.body.style.overflow = 'hidden'
        // document.body.style['padding-right'] = '15px'
        this.$el.classList.add('visible')
        setTimeout(() => this.$el.classList.add('open'), 20)
    }

    close() {
        document.body.style.overflow = null
        // document.body.style['padding-right'] = null
        this.$el.classList.remove('open')
        setTimeout(() => this.$el.classList.remove('visible'), 500)
    }
}
